import ReactGA from "react-ga";
import TagManager from "react-gtm-module";

import cookies from "js-cookie";
import { getStorage } from "./localStorage";
import dayjs from "dayjs";

const dataLayerName = "dataLayer";
const dateTimeNow = dayjs().format("YYYY-MM-DD HH:mm:ss");

export const gaInitial = (trackingId) => {
  ReactGA.initialize(trackingId);
};

export const gaSetPageView = ({ pathname = "", search = "" }) => {
  ReactGA.pageview(pathname + search);
};

export const setPageType = ({ pageType }) => {
  pushDataLayer({
    event: "SetPageType",
    page_type: pageType,
  });
};

export const setOriginalUrl = ({ originalUrl }) => {
  pushDataLayer({
    event: "SetOriginalLocationUrl",
    originalLocationUrl: originalUrl,
  });
};

export const initialDataLayer = () => {
  const tagManagerArgs = {
    gtmId: process.env.REACT_APP_GOOGLE_TAG_MANAGER_KEY,
    dataLayer: {
      event: "initialize",
      t1p_cookie_id: getStorage("t1-overview.points"),
      t1c_id: getStorage("t1-overview.card_no"),
      client_id: cookies.get("_ga"),
      first_transaction_date: "(not set)",
      log_in_status: "Logged-out",
      member_gender: "unisex",
      session_id: `${new Date().getTime()}.${Math.random()
        .toString(36)
        .substring(5)}`,
      hit_timestamp: dateTimeNow,
    },
    dataLayerName: "dataLayer",
  };

  TagManager.initialize(tagManagerArgs);
};

function pushDataLayer(data) {
  const tagManagerArgs = {
    dataLayer: data,
    dataLayerName,
  };
  TagManager.dataLayer(tagManagerArgs);
}
